// 身份管理
const identity = () => import(/* webpackChunkName: "identity" */ '../../views/identity'); // 身份管理
export default [
    {
        path: '/identity',
        name: 'identity',
        meta: { title: '身份管理', code: '111',selfFlg: 'identity', },
        component: identity, // 身份管理,

    }
];
